import React from 'react';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';
import { CollaboratorAvatar, Loader } from 'components/shared';
import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import styles from './UserProfile.module.scss';

interface UserProfileProps {
  type?: string;
}

const UserProfileQuery = gql`
  query getUserProfile {
    me {
      userProfile {
        id
        firstName
        name
        email
        avatarUrl
      }
    }
  }
`;

export const UserProfile: React.FC<UserProfileProps> = ({ type }) => {
  const { error, data } = useQuery(UserProfileQuery, {
    fetchPolicy: 'cache-first',
  });

  const showGroups = true;

  if (data === undefined) return <Loader />;

  if (error) return <Loader color="Red" />;

  return (
    <div className={styles[`type-${type}`]}>
      <div className={styles.organizationUserWrapper}>
        <NavLink
          to={`/profile/${data.me.userProfile.id}`}
          data-tid="header-profile-link"
          className={
            showGroups ? styles.user : classnames('hasTooltip tooltipBelowLeft', styles.user)
          }
          style={{ textDecoration: 'none' }}
        >
          <div className={styles.nameWrapper}>
            <CollaboratorAvatar
              bordered={false}
              className={styles.avatar}
              inheritSize
              size="Small"
              collaborator={{
                displayName: data.me.userProfile.name,
                emailAddress: data.me.userProfile.email,
                photoURL: data.me.userProfile.avatarUrl,
              }}
            />
            <div className={styles.userName}>
              {data.me.userProfile.firstName || data.me.userProfile.email}
            </div>
          </div>
        </NavLink>
      </div>
    </div>
  );
};

export default UserProfile;
